import { motion } from 'framer-motion';
import { Layers, Database, GitBranch, Shield } from 'lucide-react';

const features = [
  {
    icon: <Layers className="w-5 h-5" />,
    title: 'Full Stack Ready',
    description: 'React + FastAPI configured with best practices'
  },
  {
    icon: <Database className="w-5 h-5" />,
    title: 'Neon PostgreSQL',
    description: 'Serverless Postgres with migrations included'
  },
  {
    icon: <GitBranch className="w-5 h-5" />,
    title: 'CI/CD Pipeline',
    description: 'GitHub Actions + Terraform ready to deploy'
  },
  {
    icon: <Shield className="w-5 h-5" />,
    title: 'Auth Built-in',
    description: 'Clerk authentication pre-configured'
  }
];

export function FeaturesGrid() {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Built for real-world applications
            </h2>
            <p className="text-lg text-gray-600">
              Everything you need, nothing you don't
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <FeatureCard key={feature.title} feature={feature} index={index} />
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}

interface FeatureCardProps {
  feature: {
    icon: React.ReactNode;
    title: string;
    description: string;
  };
  index: number;
}

function FeatureCard({ feature, index }: FeatureCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 + index * 0.1 }}
      className="text-center"
    >
      <div className="inline-flex p-3 bg-white rounded-xl text-gray-700 mb-4 border border-gray-200">
        {feature.icon}
      </div>
      <h3 className="font-semibold text-gray-900 mb-2">
        {feature.title}
      </h3>
      <p className="text-sm text-gray-600 leading-relaxed">
        {feature.description}
      </p>
    </motion.div>
  );
}